<!--
 * @Author: LZH
 * @Date: 2023-04-03 10:43:52
 * @LastEditors: Do not edit
 * @LastEditTime: 2026-02-02 17:49:26
 * @Description:
-->
<template>
  <div class="home" v-if="isLoading">
    <div class="logo relative" :style="isLogoheight ? 'align-items: flex-end;' : ''">
      <div class="language">
        <DropdownMenu
          :items="store.languageType"
          placeholder=" "
          @change="handleSelection"
        ></DropdownMenu>
        <!-- <span
          v-for="item in store.languageType"
          :key="item"
          :class="language == item.value ? 'on' : ''"
          @click="setLanguage(item.value)"
          >{{ item.label }}</span
        > -->
      </div>
      <!-- height="72" -->
      <!-- 80是高度默认 -->
      <van-image
        v-if="isLogoheight"
        height="80"
        fit="scale-down"
        :src="store.ptInfo.login_logo"
      />
      <van-image v-else width="320" fit="scale-down" :src="store.ptInfo.login_logo" />
    </div>
    <div class="login-form">
      <div class="tab-wrapper">
        <!-- <div class="tab flex_box">
          <div
            :class="['tab-item', role == index ? 'active' : '']"
            v-for="(item, index) in tabArr"
            :key="index"
            @click="switchTab(index)"
          >
            {{ item }}
          </div>
        </div> -->
      </div>
      <div style="margin-top: 20px">
        <div class="flex-algin">
          <div style="padding: 10px">
            <van-image
              width="23"
              height="23"
              fit="scale-down"
              :src="store.ptInfo.account_icon"
            />
          </div>
          <div style="flex: 1; border-bottom: 1px solid #ddd">
            <van-field
              type="text"
              v-model="username"
              clearable
              :placeholder="$t('login.placeholder.account')"
            ></van-field>
          </div>
        </div>
        <div class="flex-algin">
          <div style="padding: 10px">
            <van-image
              width="23"
              height="23"
              fit="scale-down"
              :src="store.ptInfo.password_icon"
            />
          </div>
          <div style="flex: 1; border-bottom: 1px solid #ddd">
            <van-field
              type="password"
              v-model="password"
              clearable
              :placeholder="$t('login.placeholder.password')"
            ></van-field>
          </div>
        </div>
      </div>
      <div class="theme_btn login_btn theme_bg" @click="submit()">
        {{ $t("login.button.login") }}
      </div>
      <div class="registerAccount">
        <span @click="registerAccount">{{ $t("navigation.Registeraccount") }}</span>
      </div>
    </div>
    <captha
      :ref="(el) => (popupHef = el)"
      :l="42"
      :r="10"
      :colour="catcha.colour"
      :w="catcha.w"
      :h="catcha.h"
      :textTips="catcha.text"
      :blocky="catcha.blocky"
      :imgurl="catcha.imgurl"
      :miniimgurl="catcha.miniimgurl"
      @success="onSuccess"
      @fail="onFail"
      @refresh="onRefresh"
    />
  </div>
</template>

<script>
import captha from "@/components/captha.vue";
import DropdownMenu from "@/components/DropdownMenu.vue";
import { reactive, ref, toRefs, onMounted, getCurrentInstance, nextTick } from "vue";
// getCurrentInstance   //按需映入
import { getUserInfo, getUserToken, getImgHk, verifyImageCode } from "@/service/user";
import { useRouter } from "vue-router";
import beasconfig from "@/utils/beasconfig";
import { useStore } from "vuex";
import { vantLocales } from "@/lang";
import { useI18n } from "vue-i18n";
import gMethod from "@/utils/method";
export default {
  name: "LoginView",
  components: {
    captha,
    DropdownMenu,
  },
  setup() {
    const that = getCurrentInstance().appContext.config.globalProperties;
    const stores = useStore();
    const store = useStore().state;
    let $t = store.t;
    const { locale } = useI18n();
    const router = useRouter();
    const state = reactive({
      username: "",
      password: "",
      language: localStorage.getItem("language") || "en",
      tabArr: [$t("login.tag.agent"), $t("login.tag.company")],
      isLoading: false,
      catcha: {
        blocky: 0,
        imgurl: "",
        miniimgurl: "",
        text: $t("login.tips.completethepuzzle"), //向右滑动完成拼图
        h: 160,
        w: 320,
        sh: 45,
        sw: 55,
        modifyImg: "",
        token: "",
        x: 0,
        colour: "",
      },
      testandverify: false, //验证滑块
      isProject: window.XINPOC_WEB_CONFIG.isProject,
      isLogoheight: false,
    });
    const role = ref(0);
    const popupHef = ref();

    const menuOptions = [
      { label: "编辑", value: "edit" },
      { label: "删除", value: "delete" },
      { label: "分享", value: "share" },
    ];

    const handleSelection = (item) => {
      setLanguage(item.value);
    };

    const switchTab = (index) => {
      //切换登录    0代理商 1单位
      let roleId = localStorage.getItem("roleId");
      role.value = index;
      store.roleId = Number(index);
      if (store.roleId == roleId) {
        rememberPass(false);
      } else {
        rememberPass(true);
      }
    };
    const setLanguage = (lang) => {
      //切换中英文
      vantLocales(lang);
      locale.value = lang;
      state.language = lang;
      store.language = lang;
      localStorage.setItem("language", lang);
      state.tabArr = [$t("login.tag.agent"), $t("login.tag.company")];
      document.title = $t("about.title");
      // store.langMsg = lang == 'zh' ? 'cn' : lang;
      stores.commit("getlanguageMsg");
    };
    const submit = () => {
      if (!state.username || !state.password) {
        that.showToastMsg($t("message.user_password_no"));
        return;
      }
      if (!state.testandverify) {
        getImg();
        return;
      }
      that.LoadingMsg($t("message.Loggingin"));
      getUserToken({
        appId: store.appId,
        appSecret: store.appSecret,
        //user_type: role.value,
        username: state.username,
        password: state.password,
        platform: state.cuttingPlatform,
        token: state.catcha.token,
        x: state.catcha.x,
      }).then((res) => {
        that.closeToastMsg();
        state.testandverify = false;
        if (res.code == 20001) {
          let info = res.data;
          store.roleId = info.user_type;
          localStorage.setItem("roleId", info.user_type);
          sessionStorage.setItem("loginInfo", JSON.stringify(info));
          localStorage.setItem(
            "login_user",
            JSON.stringify({
              username: state.username,
              password: state.password,
            })
          );
          store.loginInfo = info;
          // if (info.isCheckagent == 0) {
          //   router.push({ path: '/perfect' });
          // } else {
          router.push({ path: "/home" });
          // }
        } else {
          that.showToastMsg(res.msg[store.langMsg]);
        }
      });
    };

    const rememberPass = (bool) => {
      //记住密码
      let login_user = JSON.parse(localStorage.getItem("login_user"));
      let roleId = localStorage.getItem("roleId");
      if (roleId && !bool) {
        role.value = roleId;
      }
      if (login_user && !bool) {
        state.username = login_user.username;
        state.password = login_user.password;
      }
      if (bool) {
        state.username = "";
        state.password = "";
      }
    };

    const onSuccess = (left) => {
      state.catcha.x = left;
      verifyImageCode({
        token: state.catcha.token,
        x: left,
      }).then((res) => {
        if (res.code == 20001) {
          // state.$message.success({
          //   message: '验证成功',
          //   customClass: "el-messageel-message",
          //   center: true,
          //   offset: 450
          // });
          state.catcha.text = $t("login.tips.Verificationissuccessful");
          state.testandverify = true;
          state.catcha.colour = "mask_ls";
          popupHef.value.handleSuccess();
        } else {
          state.catcha.colour = "mask_red";
          state.testandverify = false;
          state.catcha.text = $t("login.tips.Verificationerrorpleasetryagain");
          popupHef.value.handleFail();
          // state.getImg();
        }
      });
    };

    const onFail = (type) => {
      if (type == 1) {
        popupHef.value.isCaptha = false;
        submit();
      } else {
        getImg();
      }
    };
    const onRefresh = () => {
      //点击刷新按钮
      state.catcha.text = $t("login.tips.completethepuzzle");
      getImg();
    };

    const registerAccount = () => {
      //注册账号
      router.push({ path: "/registerAccount" });
    };

    const getImg = () => {
      //获取滑块图片
      getImgHk().then((res) => {
        let imgobj = res.data;
        state.catcha.colour = "";
        state.catcha.blocky = imgobj.y;
        state.catcha.token = imgobj.token;
        state.catcha.imgurl = "data:image/png;base64," + imgobj.bigImg;
        state.catcha.miniimgurl = "data:image/png;base64," + imgobj.SmallImg;
        state.catcha.text = $t("login.tips.completethepuzzle");
        nextTick(() => {
          if (popupHef.value) {
            popupHef.value.isCaptha = true;
            popupHef.value.reset();
          }
        });
      });
    };

    onMounted(() => {
      // getImg()
      rememberPass();
      if (!gMethod.isMobile()) {
        // _blank  //打开一个新页面
        const isMobileTime = setInterval(() => {
          //防止window加载顺序慢
          if (window.XINPOC_WEB_CONFIG.tcUrl) {
            clearInterval(isMobileTime);
            window.open(window.XINPOC_WEB_CONFIG.tcUrl, "_self");
          }
        }, 500);
        // router.push({ path: '/404' });
      }
      getUserInfo({ type: 1 }).then((res) => {
        //获取皮肤信息
        let data = res.data;
        if (data) {
          Object.keys(data).map((item) => {
            if (item.includes("_icon") || item.includes("login_logo")) {
              data[item] = beasconfig.baseUrlapi + data[item];
            }
          });
          localStorage.setItem("ptInfo", JSON.stringify(data));
          store.ptInfo = data;
          store.appId = data.appid;
          store.appSecret = data.appsecret;
          document.documentElement.style.setProperty(
            "--main-bg-color",
            res.data.top_background
          );
          document.documentElement.style.setProperty(
            "--main-cor-color",
            res.data.top_font_color
          );
          sessionStorage.setItem(
            "hfColor",
            JSON.stringify({
              bgColor: res.data.top_background,
              fontColor: res.data.top_font_color,
            })
          );
          state.isLoading = true;
        }
      });

      state.isLogoheight =
        window.XINPOC_WEB_CONFIG.isProject == "globalpoc" ? true : false;
    });
    /*禁止ios缩放，双击和双指*/
    window.onload = function () {
      document.addEventListener("touchstart", function (event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      });
      var lastTouchEnd = 0;
      document.addEventListener(
        "touchend",
        function (event) {
          var now = new Date().getTime();
          if (now - lastTouchEnd <= 300) {
            event.preventDefault();
          }
          lastTouchEnd = now;
        },
        false
      );
      document.addEventListener("gesturestart", function (event) {
        event.preventDefault();
      });
    };
    return {
      role,
      switchTab,
      ...toRefs(state),
      submit,
      setLanguage,
      store,
      onSuccess,
      onFail,
      onRefresh,
      popupHef,
      menuOptions,
      handleSelection,
      registerAccount,
    };
  },
};
</script>

<style lang="less" scoped>
// .home{
//   width: calc((100vw / (750/16)) - 0.1px);
//   height: calc((100vw / (750/30)) - 0.1px);
//   background-color: aquamarine;
// }
.logo {
  // margin-top: 150rpx;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  height: 200px;
  padding: 0 20px;
}

.login-form {
  width: 90%;
  margin: auto;
}

.tab-wrapper {
  width: 100%;

  .tab {
    font-size: 16px;

    .active {
      color: var(--main-bg-color);
      border-bottom-color: var(--main-bg-color);
    }

    &-item {
      flex: 1;
      text-align: center;
      color: #bebebe;
      padding-bottom: 8px;
      border-bottom: 2px solid #d2d2d2;
      text-align: center;
    }
  }
}

.theme_btn {
  height: 44px;
  line-height: 44px;
  padding: 0;
  text-align: center;
  background-color: var(--main-bg-color);
  color: #fff;
  font-size: 16px;
}

.login_btn {
  margin-top: 40px;
  border-radius: 22px;
}

.language {
  position: fixed;
  right: 20px;
  top: 0;
  padding: 20px 0px;
  font-size: 15px;
  z-index: 10;
}

.language span {
  display: inline-block;
  color: #606266;
  cursor: pointer;
  padding: 0 15px;
}

.language span:not(:last-child) {
  border-right: 1px solid #000000;
}

.language span.on {
  cursor: default;
  color: var(--main-bg-color); // var(--main-cor-color);
}

.registerAccount {
  color: var(--main-bg-color);
  text-align: right;
  margin: 15px 0px;
}
</style>
